import { render, staticRenderFns } from "./copiarTemplate.vue?vue&type=template&id=1d692364&scoped=true"
import script from "./copiarTemplate.vue?vue&type=script&lang=js"
export * from "./copiarTemplate.vue?vue&type=script&lang=js"
import style0 from "./copiarTemplate.vue?vue&type=style&index=0&id=1d692364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d692364",
  null
  
)

export default component.exports